import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "currency"
const CurrencyIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M21.653 7.87C22.597 10.075 22.757 12.538 22.107 14.847S20.034 19.174 18.077 20.563C16.12 21.95 13.747 22.628 11.352 22.48 9.414 22.36 7.557 21.705 5.98 20.602V22.443H4.481V17.981H8.944V19.481H7C8.316 20.36 9.848 20.884 11.444 20.983 13.497 21.11 15.531 20.529 17.208 19.339S20.105 16.42 20.662 14.441C21.22 12.46 21.083 10.35 20.274 8.459L20.964 8.165z" />
          <path d="M12.68 6.956C13.41 7.036 14.112 7.293 14.814 7.806L13.868 9.156C13.49 8.805 12.856 8.535 12.235 8.535 11.547 8.535 10.777 8.832 10.777 9.56 10.777 11.086 15.137 10.614 15.137 13.8 15.138 15.231 14.045 16.284 12.68 16.554V18.053H11.061V16.54C10.13 16.365 9.265 15.906 8.522 15.217L9.71 13.976C10.25 14.57 11.074 15.016 11.938 15.016 12.749 15.014 13.316 14.515 13.316 13.826 13.315 12.612 11.56 12.463 10.291 11.721 9.55 11.289 8.955 10.64 8.955 9.575 8.955 8.265 9.9 7.374 11.06 7.05V5.497H12.681z" />
          <path d="M19.462 5.962H15V4.462H16.915C15.618 3.616 14.118 3.113 12.555 3.017 10.504 2.89 8.47 3.47 6.793 4.66S3.896 7.58 3.338 9.56 2.917 13.649 3.726 15.54L3.036 15.835 2.346 16.13C1.404 13.924 1.244 11.46 1.894 9.152 2.544 6.842 3.967 4.826 5.923 3.437S10.253 1.371 12.648 1.52C14.563 1.638 16.398 2.28 17.963 3.359V1.499H19.462z" />
        </svg>
      }
    </span>
  )
}
export default CurrencyIcon
